import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import AppLayout from './layouts/AppLayout.vue'
import LoginPage from './pages/LoginPage.vue'
import DashboardPage from './pages/DashboardPage.vue'
import ParticipantsPage from './pages/ParticipantsPage.vue'
import CheckInPage from './pages/CheckInPage.vue'
import ConfirmedPage from './pages/ConfirmedPage.vue'
import ScanPage from './pages/ScanPage.vue'
import { createRouter, createWebHistory } from 'vue-router'
import VueToast from 'vue-toast-notification'
import 'vue-toast-notification/dist/theme-sugar.css'
import pusher from './lib/pusher'
import { isAuthenticated } from './lib/auth'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: LoginPage,
    meta: { public: true }
  },
  {
    path: '/scan',
    name: 'Scan',
    component: ScanPage,
    meta: { public: true }
  },
  {
    path: '/',
    component: AppLayout,
    children: [
      { path: '', name: 'Dashboard', component: DashboardPage },
      { path: 'participants', name: 'Participants', component: ParticipantsPage },
      { path: 'check-in', name: 'CheckIn', component: CheckInPage },
      { path: 'confirmed', name: 'Confirmed', component: ConfirmedPage },
    ]
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.public) return next()
  if (!isAuthenticated()) return next('/login')
  next()
})

const pinia = createPinia()
const app = createApp(App)

app.provide('pusher', pusher)
app.use(pinia).use(router).use(VueToast)

app.mount('#app')
